import { InjectionToken } from '@angular/core';

/**
 * Bridge to AngularJS `$rootScope` for the few cases where Angular 18 services
 * still need to emit app-wide events that legacy controllers/factories listen to
 * via `$rootScope.$on(...)`.
 *
 * Used by PermissionsService to broadcast `'PermissionsInterceptorFactory::error'`.
 */
export interface IRootScopePort {
  $broadcast(event: string, ...args: unknown[]): void;
}

export const ROOT_SCOPE_PORT = new InjectionToken<IRootScopePort>('ROOT_SCOPE_PORT');
